import { Collapse, styled, Typography } from '@mui/material';
import { motion } from 'framer-motion';

export const Item = styled(motion.button)(({ theme }) => ({
  position: 'relative',
  display: 'block',
  width: '100%',
  padding: '52px 0',
  border: 'none',
  borderBottom: `1px solid ${theme.palette.color.divider}`,
  background: 'none',
  cursor: 'pointer',
  textAlign: 'left',
  transition: 'padding var(--transition-ease-default)',

  '&:first-of-type': {
    borderTop: `1px solid ${theme.palette.color.divider}`,
  },

  '&:hover': {
    paddingLeft: '64px',

    '& .faq-index': {
      color: theme.palette.color.fg.primary,
    },

    '& .faq-question': {
      color: theme.palette.color.fg.primary,
    },

    [theme.breakpoints.down('xl')]: {
      paddingLeft: '40px',
    },
    [theme.breakpoints.down('lg')]: {
      paddingLeft: '32px',
    },
    [theme.breakpoints.down('md')]: {
      paddingLeft: '0',
    },
  },

  [theme.breakpoints.down('2xl')]: {
    padding: '40px 0',
  },
  [theme.breakpoints.down('lg')]: {
    padding: '36px 0',
  },
  [theme.breakpoints.down('md')]: {
    padding: '32px 0',
  },
  [theme.breakpoints.down('sm')]: {
    padding: '24px 0',
  },
}));

export const Row = styled('div')(({ theme }) => ({
  display: 'flex',
  alignItems: 'center',
  gap: '20px',
  width: '100%',

  [theme.breakpoints.down('md')]: {
    gap: '16px',
  },
  [theme.breakpoints.down('sm')]: {
    gap: '8px',
  },
}));

export const Index = styled(Typography, {
  shouldForwardProp: (prop) => prop !== 'isOpen',
})(({ theme, isOpen }) => ({
  flexShrink: 0,
  color: isOpen
    ? theme.palette.color.fg.primary
    : theme.palette.color.fg.unactive,
  transition: 'color var(--transition-ease-default)',
}));

export const Question = styled(Typography, {
  shouldForwardProp: (prop) => prop !== 'isOpen',
})(({ theme, isOpen }) => ({
  flex: 1,
  minWidth: 0,
  color: isOpen
    ? theme.palette.color.fg.primary
    : theme.palette.color.fg.unactive,
  transition: 'color var(--transition-ease-default)',
}));

export const Arrow = styled('img')(({ theme }) => ({
  flexShrink: 0,
  width: '30px',
  height: '30px',
  marginLeft: 'auto',

  [theme.breakpoints.down('lg')]: {
    width: '24px',
    height: '24px',
  },
  [theme.breakpoints.down('md')]: {
    width: '20px',
    height: '20px',
  },
}));

export const AnswerCollapse = styled(Collapse)(() => ({
  width: '100%',
}));

export const Answer = styled('div')(({ theme }) => ({
  width: '75%',
  paddingTop: '36px',

  '& p': {
    margin: 0,

    '& + p': {
      marginTop: '16px',
    },
  },

  [theme.breakpoints.down('2xl')]: {
    paddingTop: '20px',
  },
  [theme.breakpoints.down('md')]: {
    width: '100%',
  },
}));
